<div class="product product--layout--{{ layout }}" *ngIf="articolo">
    <div class="product__content">
        <!-- .product__gallery -->
        <div class="product__gallery">
          
        </div>
        <!-- .product__gallery / end -->
        <!-- .product__info -->
        <div class="product__info">
            <div class="product__wishlist-compare">
                <button type="button" class="btn btn-sm btn-light btn-svg-icon"
                    data-toggle="tooltip" data-placement="right" title="Wishlist" appClick
                    (click)="addToWishlist()" [ngClass]="{'btn-loading': addingToWishlist}">
                    <app-icon name="wishlist-16" size="16"></app-icon>
                </button>
                <button type="button" class="btn btn-sm btn-light btn-svg-icon"
                    data-toggle="tooltip" data-placement="right" title="Compare" appClick
                    (click)="addToCompare()" [ngClass]="{'btn-loading': addingToCompare}">
                    <app-icon name="compare-16" size="16"></app-icon>
                </button>
            </div>
            <h1 class="product__name">{{ articolo.descart }}</h1>
            <!-- <div class="product__rating">
                <div class="product__rating-stars">
                    <app-rating [value]="articolo.reviews"></app-rating>
                </div>
                <div class="product__rating-legend">
                    <a appClick>{{ articolo.reviews }} Recensioni</a><span>/</span><a
                        appClick>Scrivi La Recensione</a>
                </div>
            </div> -->
            <div class="product__description" [innerHTML]="articolo.descrizione_estesa">
            </div>
            <!-- <ul class="product__features">
                <li>Speed: 750 RPM</li>
                <li>Power Source: Cordless-Electric</li>
                <li>Battery Cell Type: Lithium</li>
                <li>Voltage: 20 Volts</li>
                <li>Battery Capacity: 2 Ah</li>
            </ul> -->
            <ul class="product__meta">
                <div class="product__meta-icons" *ngIf="articolo.ingredienti.length">
                    <img [src]="icona" width="32" height="32" *ngFor="let icona of icone_allergeni">
                    <div><a href="javascript:;" style="text-decoration: underline;" (click)="showModalIngredienti(ingredientiModal)">Visualizza ingredienti</a></div>
                </div>
                <li class="product__meta-availability">
                    <span *ngIf="isAvailable()" class="badge badge-success text-white" style="vertical-align: top; font-size: 12px;">Disponibile</span>
                    <span *ngIf="!isAvailable()" class="badge badge-danger text-white" style="vertical-align: top; font-size: 12px;">Non disponibile</span>
                </li>
                <!-- <li class="product__meta-availability" *ngIf="store.disponibilita">
                    <span>Disponibilità:&nbsp;</span>
                    <span class="badge badge-success text-white" style="vertical-align: top; font-size: 12px;" *ngIf="articolo.acquisti_giacenza_negativa">In magazzino</span>
                    <span class="badge badge-success text-white" style="vertical-align: top; font-size: 12px;" *ngIf="!articolo.acquisti_giacenza_negativa && giacenza >= 1">{{giacenza}}</span>
                    <span class="badge badge-danger text-white" style="vertical-align: top; font-size: 12px;" *ngIf="!articolo.acquisti_giacenza_negativa && giacenza < 1">Esaurito</span>
                </li> -->
                <!-- <li *ngIf="articolo.marca">Marca: {{articolo['marca']}}</li> -->
                <li>Codice Articolo: {{articolo.codart}}</li>
                <div class="marca" *ngIf="store.getMarca(articolo); let marca">Marca: {{marca.descrizione}}</div>
            </ul>
        </div>
        <!-- .product__info / end -->
        <!-- .product__sidebar -->
        <div class="product__sidebar">
            <div class="product__availability">
                <span class="text-success" *ngIf="isAvailable()">Disponibile</span>
                <span class="text-danger" *ngIf="!isAvailable()">Non disponibile</span>
            </div>
            <!-- <div class="product__availability" *ngIf="store.disponibilita">
                Disponibilità: 
                <span *ngIf="articolo.acquisti_giacenza_negativa" class="text-success">In magazzino</span>
                <span *ngIf="!articolo.acquisti_giacenza_negativa && giacenza >= 1" class="text-success">{{giacenza}}</span>
                <span *ngIf="!articolo.acquisti_giacenza_negativa && giacenza < 1" class="text-danger">Esaurito</span>
            </div> -->

            <div class="product__prices" *ngIf="!(accountService.showPrices$ | async)" style="font-size: 14px;">
                Per visualizzare i prezzi, è necessario eseguire l'accesso ed ottenere il permesso dell'amministratore.
            </div>

            <div class="product__prices" *ngIf="accountService.showPrices$ | async">
                <div *ngIf="price.hasDiscount(articolo)" style="font-size: initial;" class="text-md-left text-center">
                    <span class="product-card__badge product-card__badge--sale">-{{ price.getOffertaPercent(articolo) }}% <span *ngIf="price.offertaEndDate(articolo) as date_end">fino al {{date_end}}</span></span>
                </div>

                <div style="display: flex;align-items: center; flex-wrap: wrap">
                    <div id="price_block--wishlist" class="product__actions-item product__actions-item--wishlist d-md-none">
                        <button type="button" class="btn btn-secondary btn-svg-icon btn-lg"
                            data-toggle="tooltip" title="Wishlist"
                            [ngClass]="{'btn-loading': addingToWishlist}" appClick
                            (click)="addToWishlist()">
                            <app-icon name="wishlist-16" size="16"></app-icon>
                        </button>
                    </div>
                    <div id="price_block--price">
                        <span *ngIf="price.hasDiscount(articolo)" class="product__new-price">{{ price.prezzoArticolo(articolo, optionForm?.value) | currencyFormat }}</span>
                        <span *ngIf="!price.hasDiscount(articolo)">{{ price.prezzoArticolo(articolo, optionForm?.value)| currencyFormat }}</span>
                        <span *ngIf="(articolo.tipo_articolo == 5 || articolo.tipo_articolo == 6) && articolo.calcolo_prezzo == 1 && !articolo.flg_esplosione">&nbsp;*</span>
                    </div>
                    <div id="price_block--old">
                        <span *ngIf="price.hasDiscount(articolo)" class="product__old-price ml-2">{{ price.prezzoArticoloOld(articolo, optionForm?.value) | currencyFormat }}</span>
                    </div>

                    <div *ngIf="(articolo.tipo_articolo == 5 || articolo.tipo_articolo == 6) && articolo.calcolo_prezzo == 1 && !articolo.flg_esplosione" class="price_note">* il prezzo è indicativo e viene calcolato in base ai componenti scelti</div>

                </div>


                <div *ngIf="store.price == 'b2b'" class="text-md-left text-center" style="font-size: 14px; color:red">
                    IVA esclusa
                </div>

                <div style="font-size: initial;" class="text-md-left text-center" *ngIf="store.price == 'b2b'">
                    <div *ngIf="!articolo.confezioni_articolo.length">
                        Q.ta min.: {{articolo.minimo_acquisto}},&nbsp;
                        Q.ta succesiva: {{articolo.livello_riordino}},&nbsp;
                        Prezzo conf.: {{ price.prezzoArticolo(articolo, optionForm?.value) * articolo.minimo_acquisto | currencyFormat }}
                    </div>

                    <div *ngIf="articolo.confezioni_articolo.length" class="mt-2">
                        <label class="product__option-label" style="letter-spacing: normal;">Confezione</label>
                        <div class="conf_container">
                            <div class="conf" [ngClass]="{'active': conf_active.codice_confezione == conf.codice_confezione}"
                            *ngFor="let conf of articolo.confezioni_articolo" (click)="setConfezione(conf)">
                                {{conf.codice_confezione}} ({{conf.pezzi_confezione}} pz.) <span *ngIf="accountService.showPrices$ | async">- <span class="conf_price">{{ price.prezzoArticolo(articolo, optionForm?.value) * conf.pezzi_confezione | currencyFormat}}</span></span><br>
                                <span class="desc">{{conf.confezione_desc}}</span>
                            </div>
                        </div> 
                    </div>
                </div>

            </div>
            <!-- .product__options -->
            <form class="product__options">
                <ng-container *ngFor="let i of [1,2,3,4]">
                    <div *ngIf="articolo['optionlist' + i]" class="form-group product__option">
                        <label class="product__option-label">{{articolo['optionlist' + i].descrizione}}</label>
                        <div class="input-radio-label">
                            <div class="input-radio-label__list">
                                <label *ngFor="let option of articolo['option_disponibili_' + i]">
                                    <input type="radio" [name]="articolo['optionlist' + i].option_list"
                                    [value]="option.progressivo"
                                    [formControl]="optionForm.controls[i]"
                                    [ngClass]="{'not-available': !isOptionAvailable(i, option.progressivo)}">
                                    <span class="input-radio-label__content">
                                        <span *ngIf="[1,2].includes(option.display_type) && option.display_ext" [ngStyle]="{'color': ([3,6].includes(option.display_ext.length) ? '#' : '') + option.display_ext}" class="input-radio-label__content-color"></span>
                                        <span *ngIf="[2].includes(option.display_type) && option.display_ext">&nbsp;&nbsp;</span>
                                        <span *ngIf="[0, 2].includes(option.display_type)" class="input-radio-label__content-text">{{option.codice}}</span>
                                        <span *ngIf="option.display_type == 3"><img [src]="option.display_ext" width="48" height="48"></span>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-container>
            
                <div class="form-group product__option" *ngIf="accountService.showPrices$ | async">
                    <label class="product__option-label">Quantità</label>&nbsp;<br class="d-none d-xs-inline">
                    <label *ngIf="countOfItemInCart as qtyInCart" style="font-size: 13px">
                        (nel carrello: {{qtyInCart}})
                    </label>
                    <div class="product__actions">
                        <div class="product__actions-item">
                            <app-input-number aria-label="Quantita" class="product__quantity"
                                size="lg" [min]="min" [max]="giacenza" [step]="step" [disabled]="canAddToCart() ? null : true"
                                [canSubBeDisabled]="true" [formControl]="quantity"></app-input-number>
                        </div>

                        <div class="d-lg-none" style="flex-basis: 100%; height: 0;"></div> 

                        <div class="product__actions-item product__actions-item--addtocart">
                            <button type="button" class="btn btn-primary btn-lg"
                                [ngClass]="{'btn-loading': addingToCart}" appClick
                                (click)="addToCart()" [attr.disabled]="canAddToCart() ? null : true"
                                >Aggiungi al carrello</button>
                        </div>
                        <div class="product__actions-item product__actions-item--wishlist d-none d-md-block">
                            <button type="button" class="btn btn-secondary btn-svg-icon btn-lg"
                                data-toggle="tooltip" title="Wishlist"
                                [ngClass]="{'btn-loading': addingToWishlist}" appClick
                                (click)="addToWishlist()">
                                <app-icon name="wishlist-16" size="16"></app-icon>
                            </button>
                        </div>
                        <!-- <div class="product__actions-item product__actions-item--compare">
                            <button type="button" class="btn btn-secondary btn-svg-icon btn-lg"
                                data-toggle="tooltip" title="Compare"
                                [ngClass]="{'btn-loading': addingToCompare}" appClick
                                (click)="addToCompare()">
                                <app-icon name="compare-16" size="16"></app-icon>
                            </button>
                        </div> -->
                    </div>
                    <div *ngIf="articolo.non_acquistabile" class="mt-2" style="color:red">Articolo acquistabile solo in negozio</div>
                </div>
            </form>
            <!-- .product__options / end -->
        </div>
        <!-- .product__end -->
        <!-- <div class="product__footer">
            <div class="product__tags tags">
                <div class="tags__list">
                    <a href="" appClick>Mounts</a>
                    <a href="" appClick>Electrodes</a>
                    <a href="" appClick>Chainsaws</a>
                </div>
            </div>

            <app-share-buttons
                class="product__share-buttons"
                [buttons]="['facebook', {type: 'twitter', label: 'Tweet'}, 'pinterest']"
                [pageUrl]="root.product(product)|absoluteUrl:'angular'"
                [pageTitle]="product.name"
                [pageImage]="product.images[0]|absoluteUrl:'html'"
            ></app-share-buttons>
        </div> -->
    </div>
    
    <div itemtype="https://schema.org/Product" itemscope>
        <meta itemprop="name" [content]="articolo.descart" />
        <ng-container *ngFor="let url of img_for_google">
            <link itemprop="image" [href]="url" />
        </ng-container>
        <meta *ngIf="articolo.descrizione_estesa" itemprop="description" [content]="articolo.descrizione_estesa" />
        <div itemprop="offers" itemtype="https://schema.org/Offer" itemscope>
            <link itemprop="url" [href]="currentUrl()" />
            <meta itemprop="availability" [content]="isAvailable() ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock'" />
            <meta itemprop="priceCurrency" content="EUR" />
            <meta itemprop="itemCondition" content="https://schema.org/NewCondition" />
            <ng-container *ngIf="accountService.showPrices$ | async">
                <meta itemprop="price" [content]="price.prezzoArticolo(articolo, optionForm?.value)" />
                <meta *ngIf="price.hasDiscount(articolo)" itemprop="priceValidUntil" [content]="articolo.scadenza_promozionale.split('T')[0]" />
            </ng-container>
        </div>
    </div>
</div>

<ng-template #ingredientiModal>
    <div class="quickview">
        <button class="quickview__close" type="button" appClick (click)="ingredientiModalRef.hide()">
            <app-icon name="cross-20" size="20"></app-icon>
        </button>

        <div class="text-center mt-2 mb-2">
            <h4>Ingredienti - {{articolo.descart}}</h4>
            <div class="card-divider"></div>
            <div class="card-table">
                <div class="table-responsive-md">
                    <table style="width: 100%; text-align: center;">
                        <thead>
                            <tr>
                                <th>Ingredienti</th>
                                <th>Allergeni</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ingrediente of articolo.ingredienti">
                                <td [ngClass]="{'font-weight-bold': ingrediente.flg_allergene}">{{ingrediente.descrizione}}</td>
                                <td>
                                    <div *ngFor="let allergene of ingrediente.dati; let isLast=last" style="display: inline-block" class="m-2">
                                        <img width="32" height="32" [src]="allergene.icona" *ngIf="allergene.icona">
                                        {{allergene.descrizione}}{{isLast ? '' : ', '}}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-divider"></div>
        </div>
    </div>
</ng-template>